// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2Px22","control":"Login_control__1O9dn","invalid":"Login_invalid__1Kvhn","actions":"Login_actions__1b5Oz","signup":"Login_signup__2SjWN"};